/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_increase_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What if the result is negative?`)
};

const es_pct_increase_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué pasa si el resultado es negativo?`)
};

const de_pct_increase_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was, wenn das Ergebnis negativ ist?`)
};

const nl_pct_increase_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat als het resultaat negatief is?`)
};

const fr_pct_increase_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que se passe-t-il si le résultat est négatif ?`)
};

const it_pct_increase_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cosa succede se il risultato è negativo?`)
};

const pt_br2_pct_increase_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E se o resultado for negativo?`)
};

const pt_pct_increase_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E se o resultado for negativo?`)
};

const ja_pct_increase_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`結果がマイナスになった場合は？`)
};

const zh_pct_increase_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如果结果是负数怎么办？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_increase_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_increase_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_increase_faq2_q", locale)
	if (locale === "en") return en_pct_increase_faq2_q(inputs)
	if (locale === "es") return es_pct_increase_faq2_q(inputs)
	if (locale === "de") return de_pct_increase_faq2_q(inputs)
	if (locale === "nl") return nl_pct_increase_faq2_q(inputs)
	if (locale === "fr") return fr_pct_increase_faq2_q(inputs)
	if (locale === "it") return it_pct_increase_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_pct_increase_faq2_q(inputs)
	if (locale === "pt") return pt_pct_increase_faq2_q(inputs)
	if (locale === "ja") return ja_pct_increase_faq2_q(inputs)
	return zh_pct_increase_faq2_q(inputs)
};